import { defaultDataIdFromObject, IdGetterObj } from 'apollo-cache-inmemory'
import { ArtboardDetailInfoFragment } from 'gqlTypes'
interface ShortIdGetterObj extends Object {
  __typename?: string
  shortId?: string
  permanentArtboardShortId?: string
  documentVersionShortId?: string
}

interface IdentifierGetterObj extends Object {
  __typename?: string
  identifier?: string
}

export const dataIdFromObject = (
  object: IdGetterObj | ShortIdGetterObj | IdentifierGetterObj
): string | null | undefined => {
  switch (object.__typename) {
    case 'Artboard': {
      const artboard = object as ArtboardDetailInfoFragment
      return `${artboard.__typename}::${artboard.permanentArtboardShortId}::${artboard.documentVersionShortId}`
    }

    case 'Organization':
    case 'Version':
    case 'ArtboardBase': {
      const artboardBase = object as ArtboardDetailInfoFragment
      return `${artboardBase.__typename}::${artboardBase.shortId}`
    }
    case 'Plans': {
      /*
       * "defaultDataIdFromObject" will return null if the object doesn't contain
       * by default an "id" or "_id".
       *
       * Since the "Plans" object doesn't have an ID associated with it, it won't work for "defaultDataIdFromObject",
       * that's why we are forcing one here. So we register the object in cache and access it later on.
       */

      return `${object.__typename}`
    }
    default: {
      const anyObject = object as IdentifierGetterObj
      if (anyObject.identifier) {
        return defaultDataIdFromObject({
          __typename: anyObject.__typename,
          id: anyObject.identifier,
        })
      }
      return defaultDataIdFromObject(object)
    }
  }
}
